import { QueryClient } from '@tanstack/react-query'

import { isolateAcademyQueries } from './academy-session'

export function createAcademyQueryClient() {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: 0 },
    },
  })
  const dispose = isolateAcademyQueries(client)
  return { client, dispose }
}
